<template>
    <a v-if="community" :href="'/' +  community.url" :class="{ 'active' : !isHovered }" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
        <img
            v-if="community.thumb"
            :srcset="$simpleStore.transformImageWithCloudfront(width, height, community.thumb, $root, 'srcset')"
            :src="$simpleStore.transformImageWithCloudfront(width, height, community.thumb, $root)" alt="" class="image"
        >
        <img
            :srcset="$simpleStore.transformImageWithCloudfront(logoSize, logoHeight, 'img/communities/' + community.community_id + '/' + community.image, $root, 'srcset')"
            :src="$simpleStore.transformImageWithCloudfront(logoSize, logoHeight, 'img/communities/' + community.community_id + '/' + community.image, $root)"
            alt="" class="logo" :width="logoHeight ? logoSize : null" :height="logoHeight"
        >
        <div v-html="community.name" :class="['name', height >= width ? 'portrait' : '']" class="name"></div>
    </a>
</template>

<script>
export default {
    props: {
        linkClass: {
            type: String,
            default: 'active'
        },
        height: Number,
        width: Number,
        reset: Boolean,
        logoDims: {
            type: Number,
            default: 54
        }
    },
    data() {
        return {
            community: null,
            count: 0,
            hover: false,
            isHovered: false,
            trendingThumbnails: this.$root.trendingThumbnails,
        }
    },
    created() {
        if (this.reset) {
            this.$simpleStore.heroCount = 0;
        }
        this.community = this.getCommunity();
    },
    computed: {
        logoSize() {
            // logo-only tiles (white-label brands, no thumb) fill most of the tile
            // (up to ~200px on the largest tiles) - request a matching image size so
            // it stays sharp
            return this.community && !this.community.thumb ? 200 : this.logoDims;
        },
        logoHeight() {
            // logo-only tiles scale by width only (c_scale, no crop) so the logo's
            // aspect ratio is preserved; photo-backed tiles keep the square crop
            return this.community && !this.community.thumb ? null : this.logoDims;
        }
    },
    methods: {
        getCommunity() {
            const items = this.trendingThumbnails;
            if (!items || !items.length) return null;
            const index = this.$simpleStore.heroCount++;
            // don't wrap around - a surplus tile renders empty rather than repeating a community
            if (index >= items.length) return null;
            return items[index];
        }
    }
}
</script>
